import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Product, ProductEnum } from '@uc/web/shared/data-models';
import {
	ClearingVisitWebsiteBtnComponent,
	VisitWebsiteBtnComponent,
} from '@web/shared/ui';

@Component({
	selector: 'uc-recommended-visit-website-btn',
	templateUrl: './recommended-visit-website-btn.component.html',
	imports: [ClearingVisitWebsiteBtnComponent, VisitWebsiteBtnComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendedVisitWebsiteBtnComponent {
	externalUrl = input.required<string>();
	uniId = input.required<number>();
	uniName = input.required<string>();
	searchOrderPosition = input.required<number | null>();
	componentName = input.required<string>();
	privacyPolicyUrl = input.required<string | null>();
	product = input<Product>(ProductEnum.Undergraduate);
	customStyles = input<string>('');
	buttonText = input<string>('Visit website');

	readonly clearing = ProductEnum.Clearing;
}
